import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbAccordionConfig, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from '../../services/login.service';
import { Observable, Subject } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  providers: [NgbAccordionConfig, NgbModal]
})
export class LoginModalComponent implements OnInit, OnDestroy {

  @ViewChild('expired', { static: false }) expired: NgbModal;
  @ViewChild('content', { static: true }) content: any;

  isIEOrEdge: boolean;

  email: string;
  loggedInUser:string;
  password: string;
  authenticated: boolean;
  authenticationFailure: string;

  pwInputType = "password";
  loginClicked = false;

  private unsubscribe: Subject<any> = new Subject();
  loading: boolean = false;
  returnUrl: string;

  constructor(
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal,
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService) {
    modalConfig.backdrop = 'static';
  /* If navigating to this, open login modal */
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) { /* Your code goes here on every router change */
        if (this.authenticated == false) {
          //this.open();
        }}
    });
  }

  ngOnInit() {
    // M$ uses their own show/hide password, so this is for detecting and disabling our custom show/hide button
    this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    this.loginService.expired.subscribe(expired => {
      if (expired === true) {
        this.expiredPopup();
        this.loginService.changeExpired(false);
      }
    });

    this.loginService.loggedInUser.subscribe(user => {
      this.loggedInUser = user;
    })

    this.loadingService.currentLoading
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(loading => {
      this.loading = loading;
    });

    this.loginService.authenticated
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(authenticated => {
        this.authenticated = authenticated;
      })

    if (this.authenticated == false) {
      //this.open();
    }

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  open() {
    this.modalService.open(this.content, { ariaLabelledBy: 'login-modal', centered: true });
    this.authenticationFailure = null;
  }

  showPasswordToggle() {
    if (this.pwInputType === "password") {
      this.pwInputType = "text";
    } else {
      this.pwInputType = "password";
    }
  }

  async login() {
    this.loginClicked = true;
    let loginResult = await this.loginService.login(this.email, this.password);
    this.authenticationFailure = loginResult.failureMessage;
    this.password = null;
    this.loginClicked = false;
    if (!this.authenticationFailure) {
      setTimeout(() => {
        this.modalService.dismissAll();
      }, 1000);  
    }
  }

  logout() {
    this.loginService.logout();
    this.loginClicked = false;
    this.router.navigateByUrl('/login');
  }

  expiredPopup() {
    this.modalService.open(this.expired);
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 2500);
  }

}
